import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useRef } from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { usePuzzleNavigationContext } from '../../context.js';
import { HeaderInputWrapper, HeaderWrapper, ItemsWrapper, Wrapper } from './styled.js';
export const ItemsList = memo(function ItemsList({ children, header, companySelect, searchInput, timer, footer, mobileHeaderHeight, }) {
    const { isCollapsedNav, activeKey, setActiveKey } = usePuzzleNavigationContext();
    const itemsWrapper = useRef(null);
    const handleOnScroll = useCallbackRef(() => {
        if (isCollapsedNav && activeKey) {
            setActiveKey(null);
        }
    });
    return (_jsxs(Wrapper, { $collapsed: isCollapsedNav, "data-collapsed": isCollapsedNav ? 'true' : 'false', children: [_jsxs(HeaderWrapper, { $isCollapsedNav: isCollapsedNav, $isCompanySwitchView: !!companySelect, $mobileHeaderHeight: mobileHeaderHeight, children: [header, (companySelect || searchInput || timer) && (_jsxs(HeaderInputWrapper, { $isCollapsedNav: isCollapsedNav, children: [companySelect, searchInput, timer] }))] }), _jsx(ItemsWrapper, { ref: itemsWrapper, onScroll: handleOnScroll, children: children }), footer] }));
});
